import React, { useState,useEffect }  from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';

import { BASE_URL } from '../Config/Base';
//import { ToastContainer, toast } from 'react-toastify';
import { Oval } from  'react-loader-spinner'
import _ from 'lodash'

// import jsPDF from "jspdf";
// import autoTable from 'jspdf-autotable';
const pageSize =5;
const TecFirstMain = () => {

  useEffect(()=>{ 
    
    document.getElementById("PopAAdd").style.display="none"
    document.getElementById("PopATable").style.display="none"
    // getparticularRole()
    // getExpertiseList()
   
    getTecFirst()
    setpop(true);
    setTimeout(() => {
            
      getroleAction() 
      
       }, 1000);
    setTimeout(() => {
            
      setpop(false);
      getAssignedAction()
    
        
       }, 2000);

    //  getcheck()



   
  }, [])
  const[pop,setpop] = useState(false);
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

  const [sectionFirst, setSectionFirst] = useState([])
  const [paginatedPosts, setpaginatedPosts] = useState();
  const [currentPage, setcurrentPage] = useState(1);


  const [EditSectionFirst, setEditSectionFirst] =useState([])
  const [fileFirst, setFileFirst] = useState();
  const [fileFirstImg, setFileFirstImg] = useState();


  const[editicon,setediticon] = useState(false);
   const[delicon,setdelicon] = useState(false);
  const[denied,setdenied] = useState(false);    

  const[SuccessToast,setSuccessToast] = useState(false);  
  const[UpdateToast,setUpdateToast] = useState(false);  
  const[DeleteToast,setDeleteErrToast] = useState(false);

  //let Pdata =  JSON.parse(localStorage.getItem("CheckData"));
  //let Parsedata = JSON.parse(Pdata);
  //let ppdata = Pdata.map((item) => item.text);

// function getcheck(){


 


// let text = ppdata[0]

// let para = document.getElementById("demo").value;
// let paraA = document.getElementById("demoA");	




//  let str = para.replace((1), "<br>");
//  let	str1 =str.replace((2), "<br>");
//  let	str2 =str1.replace((3), "<br>");
//  let	str3 =str2.replace((4), "<br>");
//  let	str4 =str3.replace((5), "<br>");
//  let	str5 =str4.replace((6), "<br>");

//  paraA.innerHTML = str5;
// }



  ///getTecFirst


  function getTecFirst()
  {

 
  

  fetch(`${BASE_URL}/Tec/Gettecfirst`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("DatasectionA", data);
      setSectionFirst(data)
      setpaginatedPosts(_(data).slice(0).take(pageSize).value());
      localStorage.setItem("CheckData", JSON.stringify(data));
        }
    );



      }
     
     
      const pageCount = sectionFirst? Math.ceil(sectionFirst.length/pageSize) :0;
// if (pageCount === 1)
// return null;

const pages = _.range(1, pageCount+1)

const pagination =(pageNo)=>{

  // if (pageCount === 1)
// return null;
setcurrentPage(pageNo);
const startIndex = (pageNo - 1) * pageSize;
const paginatedPost = _(sectionFirst).slice(startIndex).take(pageSize).value();
setpaginatedPosts(paginatedPost)
}
const onNext = () => {


  pagination(currentPage + 1);
};

const onPrevious = () => {
  pagination(currentPage - 1);
};

      ///submitsection


   // console.log(file)
   
   const handleFileChangeFirst = (e) => {
    
       setFileFirst(e.target.files[0]);
       setFileFirstImg(URL.createObjectURL(e.target.files[0]));
       console.log(fileFirst)
      
   };
 
   function submitsectionFirst(){

    var UserId= localStorage.getItem('UserId')

     var textFirst = document.getElementById("text").value;


     if(!textFirst){

       document.getElementById("AddErrA").innerHTML="Content Required"

     }
     else if(textFirst){

       document.getElementById("AddErrA").innerHTML=" "

     }
     
     if(!fileFirst){

       document.getElementById("AddErrB").innerHTML="image Required"

     }
     else if(fileFirst){

       document.getElementById("AddErrB").innerHTML=" "

     }

     if(textFirst &&fileFirst){



    const body =
     {
       
       Text:textFirst, 
       Image:fileFirst,
       ActiveStatus:0,
       DeleteStatus:0,
       CreatedBy:UserId

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/Addtecfirst`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
          
            //  toast.success("Section Added")
             setSuccessToast(true)
          
             setTimeout(() => {
              setSuccessToast(false)
              getTecFirst()

              closeFirstAddForm()
             }, 2000);
           }

   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed to Add") 

     })
       
   }

   }


   
     ////Get Particular Data PostMethod
     const [Edittec, setEdittec] =useState([])
     function SelectParticular(Id){


      const body =
     {
       
      id:Id
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/Edittecfirst`,
            data:body, 
            headers: {
                 "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
         
    
         .then((response) =>{
           console.log(JSON.stringify(response.data));
      
          
           setEditSectionFirst(response.data)
           setEdittec(response.data)
          
      
        })
        .catch(error => {
          console.log(error);
          
        })
     }


     function editSectionFirst(Id){

      SelectParticular(Id)
      document.getElementById("FirstEditPop").style.display = "block";
 
    

     }

 //function closeform

 function closeForm(){

  document.getElementById("modaldeleteForm").style.display ="None"

}

     function updateSectionFirst(Id){


       var UserId= localStorage.getItem('UserId')
       var TextFirst = document.getElementById("textA").value;
       var ImagefileFirst = document.getElementById("tecimage").src;

       if(!TextFirst){

         document.getElementById("ErrA").innerHTML="Content Required"

       }
       else if(TextFirst){

         document.getElementById("ErrA").innerHTML=" "

       }
       
      
      
      
       if(TextFirst){


       



    const body =
     {
       Id:Id,
       Text:TextFirst, 
       Image:fileFirst,
       OldImage:ImagefileFirst,
       EditedBy:UserId

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/Updatetecfirst`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
        localStorage.setItem("CheckData", JSON.stringify(response.data));
     

        if(response.data.status === "Success"){
          closeFirstEditForm()
            //  toast.success("Section Updated")
            setUpdateToast(true)
             setTimeout(() => {
             
              getTecFirst()
              setUpdateToast(false)
              setcurrentPage(1)
             }, 2000);
           }
   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed to Update")   
     })
       
    
   }

     }
     function ConfirmDelete(Id){

      SelectParticular(Id)
      setTimeout(() => {
        document.getElementById("modaldeleteForm").style.display = "block";
      },1000);
    
    }

   ///DeleteSectionA

   function DeleteSectionFirst(Id){

 
  

    const body =
     {
       Id:Id,
    
      

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/Deletetecfirst`,
            data:body, 
            headers: {
               "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
        closeForm()
           setDeleteErrToast(true)
        
            //  toast.info("Section Deleted")
           
             setTimeout(() => {
             
              getTecFirst()
              
              setcurrentPage(1)
              setDeleteErrToast(false)
             }, 2000);
            
             
           
   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     alert("failed to Update")   
     })
       
    

   

   }





   //closeAddForm

   function closeFirstAddForm(){


    setFileFirst();
   
    setFileFirstImg();
    document.getElementById("AddErrA").innerHTML=" "
    document.getElementById("AddErrB").innerHTML=" "
   
    document.getElementById("tecform").reset();

  
   
             
      document.getElementById("FirstAddPop").style.display = "none";
      document.getElementById("inputtecboxB").innerText= " "
      
     
    // 
           
   
   
   
  }

 
  
   //closeEditForm

  function closeFirstEditForm(){

   setFileFirst();
   setFileFirstImg();
   document.getElementById("ErrA").innerHTML=" "
   document.getElementById("ErrB").innerHTML=" "
   document.getElementById("teceditform").reset();

   
   document.getElementById("FirstEditPop").style.display = "none";
  }


  //OpenAddForm

  function openFirstForm(){

    document.getElementById("FirstAddPop").style.display = "block";

  }


  
 




 
function getroleAction(){


 let LoginRole= localStorage.getItem("Role");
 

 console.log('checkrole',LoginRole);
 const body =
 {
   
  role:LoginRole
 }
 console.log('body',body);


 axios({
        method:"POST",
        url :`${BASE_URL}/Tec/GetTecRoleAction`,
        data:body, 
        headers: {
             "Content-type": "application/json",
             "Authorization": bearer,
         }     
     }) 
     

     .then((response) =>{
       console.log(response.data);
  
    
    
             
       localStorage.setItem("LoginAction",JSON.stringify(response.data))
       localStorage.getItem("LoginAction");
    })
    .catch(error => {
      console.log(error);
})
}

 
 function getAssignedAction(){



  ////Admin
    
    let LoginRoleId= localStorage.getItem("RoleId");

    let CheckSAdmin = LoginRoleId.includes("00")
    let CheckAdmin =LoginRoleId.includes("01")


  /////////////Teammate
    let LoginAction =  localStorage.getItem("LoginAction");
    let TecRoleAction =  JSON.parse(LoginAction);
    let roleAction = TecRoleAction.map((e)=>e.roleAction);
    console.log(roleAction);
    
    let roles = roleAction.toString();
    let roleResult = roles.includes('Add')
    console.log(roleResult)
    
    let roleResultA = roles.includes('View')
    console.log(roleResultA)
    
    let roleResultB = roles.includes('Edit')
    console.log(roleResultB)
    
    let roleResultC = roles.includes('Delete')
    console.log(roleResultC)


   

    if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById('PopAAdd').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('PopAAdd').style.display ="block";
    }
    else{
      document.getElementById('PopAAdd').style.display ="none";

    }
    if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById('PopATable').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('PopATable').style.display ="block";
    }
    else{
      document.getElementById('PopATable').style.display ="none";

    }
    if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
  
      setediticon(true)
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      setediticon(true)
    }
    else{
      setediticon(false)

    }
    if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){

      setdelicon(true)
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      setdelicon(true)
    }
    else{
      setdelicon(false)

    }

    if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){

      setdenied(true)
    }
    else{

      setdenied(false)
    }

    if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
   document.getElementById("TecActionDenied").innerHTML="View Table is not Assigned"
    }
  }
 
//  function  downloadTable (){
  
//       const doc = new jsPDF();
//       autoTable(doc, { html: '#table_with_data' });
//       doc.save('table.pdf')
//   }



    
  return (
    <div className='tec-addmain'>
      
    {/* <ToastContainer id="toast"
        position="top-center"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        /> 
         */}
  {/* <div className="tec-addgrid-layout">
<div className="tec-addmain-top">
  <div className='tec-addmain-back'>
  <Link to='/Tecsection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
  </div> 
  <span>First</span>
  
  </div>
  </div> */}

<div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">HEADING</span> </span>
 
 <div className='tec-addmain-back'>
<Link to="/TecIndex"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
</div></p> 

 {/* <hr></hr> */}
 </div>
    </div>  

      {/* Toast */}
    {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Added Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {DeleteToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Deleted Successfully</p></div>
   
  </div></div></div></div>:null} 


   {/* Toast */}
   {UpdateToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Updated Successfully!</p></div>
   
  </div></div></div></div>:null}
  <div className='tec-addmain-add' id="PopAAdd">
      <button className='add-user' onClick={openFirstForm}> Add Heading</button>
 </div>
 
  <div>

 

 
 {/* EditFirst */}
 <div className='tec-pop-fade' id="FirstEditPop">
{EditSectionFirst.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"150px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT HEADING</h4>
        <button type="button" className="close" onClick={closeFirstEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="teceditform" onSubmit={()=>updateSectionFirst(e.id)}>
      <div className="modal-body mx-3">
      <div className="text-center md-form mb-5" style={{marginTop:"-25px"}}>
        {/* <label id="sectionlable">Image</label> */}
        <input type="file"  onChange={handleFileChangeFirst} style={{opacity:"0",position:"relative",top:"50px",left:"200px",zIndex:"1"}}  />
        {!fileFirstImg?<img id="tecimage" src={e.image} /> : <img id="tecimage" src={fileFirstImg} /> }
        <span id="editimg-Tec"><i class="fa fa-pencil" aria-hidden="true" ></i></span>
         
         <span id="ErrB" className='error'></span>
        </div>
        <div className="md-form mb-4">
        <label id="sectionlable">Content</label> 
          <input type="text" id="textA"  defaultValue={e.text}/>
          <span id="ErrA" className='error'></span>
        </div> 
        
       
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>

{/* AddFirst */}
<div className='tec-pop-fade' id="FirstAddPop">

  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"170px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD HEADING</h4>
        <button type="button" className="close" onClick={closeFirstAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecform" onSubmit={submitsectionFirst} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
           
        <label id="sectionlable">Content</label> 
          <input type="text" id="text"/>
          <span id="AddErrA" className='error'></span>
        </div> 
        
        <div className="md-form mb-5">
          <label id="sectionlable">Image</label>  
 
         <input type="file" onChange={handleFileChangeFirst}/>
         
         <span id="AddErrB" className='error'></span>
        </div>
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
  </div>

</div> 


    <div className='tec-sectionMain' id="PopATable" >
  

{/* <input id="demo" defaultValue={ppdata} />
<p id="demoA"></p> */}

{
  sectionFirst.length==0  ? <div id="TecApiFail">" No Data Found "</div> :(<div>

<div className='tectable'>

  <div class="tec-table_responsive">
<table>
  <thead>
    <tr>
      <th>Content</th>
      <th>Image</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {paginatedPosts.map((e)=>{
    
  
    return<tr>
    <td><div style={{inlineSize:"300px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.text}</div></td>
  
    <td><img src={e.image} alt="imgA" id="sectionImage"></img></td>
    <td style={{whiteSpace:"nowrap"}}>
    {editicon? <span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionFirst(e.id)} id="tecEditicon"></i></span>:null} &nbsp;&nbsp;

     {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id)} id="tecDelicon"></i></span>:null}

     {denied?<span className='error'>Denied</span>:null}
    </td>
    </tr>
 } )}
  </tbody>
</table>
</div>
</div>

<br></br>
{pageCount==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>pagination(page)}>
            {page}
            </p>
            </li>
        ))
      } */}
        {currentPage >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="tecpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}

  </div>)}
 



  {/*  {SectionExpertiseImage.map((e)=>{
    return<div id="ExpertiseImagediv">

 <img src= {e.image} id="ExpertiseImage"></img>  </div>} )} */}
    </div>
    </div>

    {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}


     {/* DeletePopup */}

   {Edittec.map((e)=>{ 
   return<div className="tec-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionFirst(e.id)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}
<div id="TecDenied">
   <span id="TecActionDenied"></span>

   </div>
    </div>
  )
}

export default TecFirstMain
